module.exports = __webpack_public_path__ + "img/style_8_en.412fae92.jpeg";